export default "__VITE_ASSET__BN2j$9Gn__"